import { gql } from 'graphql-tag'

const scoreCardStatsFragment = gql`
  fragment ScoreCardStatsFragment on ScoreCardStats {
    actual
    high
    low
  }
`

const sectionThresholdsFragment = gql`
  fragment SectionThresholdsFragment on SectionThresholds {
    high
    low
  }
`

export const timePeriodFragment = gql`
  fragment ScoreCardTimePeriodFragment on ScoreCardTimePeriods {
    yesterday: yesterday {
      ...ScoreCardStatsFragment
    }

    thisWeek: thisWeek {
      ...ScoreCardStatsFragment
    }

    lastWeek: lastWeek {
      ...ScoreCardStatsFragment
    }

    thisMonth: thisMonth {
      ...ScoreCardStatsFragment
    }

    lastMonth: lastMonth {
      ...ScoreCardStatsFragment
    }

    lastYearToDate: lastYearToDate {
      ...ScoreCardStatsFragment
    }

    thisYearToDate: thisYearToDate {
      ...ScoreCardStatsFragment
    }

    rollingMonth: rollingMonth {
      ...ScoreCardStatsFragment
    }

    rollingYear: rollingYear {
      ...ScoreCardStatsFragment
    }

    section

    sectionThresholds {
      ...SectionThresholdsFragment
    }
  }
  ${scoreCardStatsFragment}
  ${sectionThresholdsFragment}
`

const scoreCardFragment = gql`
  fragment ScoreCardFragment on NewScoreCardCategories {
    incentiveSales {
      ...ScoreCardTimePeriodFragment
    }
    thumbsUp {
      ...ScoreCardTimePeriodFragment
    }
    toiletChecks {
      ...ScoreCardTimePeriodFragment
    }
    feelingMeterAverage {
      ...ScoreCardTimePeriodFragment
    }
    feelingMeterUsage {
      ...ScoreCardTimePeriodFragment
    }
    dailyChecklistUsage {
      ...ScoreCardTimePeriodFragment
    }
    dailyInfoUsage {
      ...ScoreCardTimePeriodFragment
    }
    buffetWastage {
      ...ScoreCardTimePeriodFragment
    }
    alacarteWastage {
      ...ScoreCardTimePeriodFragment
    }
    sweetWastage {
      ...ScoreCardTimePeriodFragment
    }
    saltyWastage {
      ...ScoreCardTimePeriodFragment
    }
    pizzatableWastage {
      ...ScoreCardTimePeriodFragment
    }
    abcpizzaWastage {
      ...ScoreCardTimePeriodFragment
    }
    abcburgerWastage {
      ...ScoreCardTimePeriodFragment
    }
    fastfoodWastage {
      ...ScoreCardTimePeriodFragment
    }
    pikacarteWastage {
      ...ScoreCardTimePeriodFragment
    }
    arnoldsWastage {
      ...ScoreCardTimePeriodFragment
    }
    breakfastWastage {
      ...ScoreCardTimePeriodFragment
    }
    buffetWorldWastage {
      ...ScoreCardTimePeriodFragment
    }
    totalBudgetEfficiency {
      ...ScoreCardTimePeriodFragment
    }
    budgetEfficiency {
      ...ScoreCardTimePeriodFragment
    }
    targetEfficiency {
      ...ScoreCardTimePeriodFragment
    }
    totalSalesEfficiency {
      ...ScoreCardTimePeriodFragment
    }
    hourlyHallChecklistUsage {
      ...ScoreCardTimePeriodFragment
    }
    hourlyBuffetChecklistUsage {
      ...ScoreCardTimePeriodFragment
    }
    hourlyVitrineChecklistUsage {
      ...ScoreCardTimePeriodFragment
    }
    hourlyMarketChecklistUsage {
      ...ScoreCardTimePeriodFragment
    }
    impulseSales {
      ...ScoreCardTimePeriodFragment
    }
    freshBakeryWastage {
      ...ScoreCardTimePeriodFragment
    }
    readyMealsWastage {
      ...ScoreCardTimePeriodFragment
    }
    fruitsAndVegetablesWastage {
      ...ScoreCardTimePeriodFragment
    }
    breweryDrinkWastage {
      ...ScoreCardTimePeriodFragment
    }
    flowersWastage {
      ...ScoreCardTimePeriodFragment
    }
    meatWastage {
      ...ScoreCardTimePeriodFragment
    }
    dryGroceriesWastage {
      ...ScoreCardTimePeriodFragment
    }
    juicesWastage {
      ...ScoreCardTimePeriodFragment
    }
    cheesesWastage {
      ...ScoreCardTimePeriodFragment
    }
    liquidDairyWastage {
      ...ScoreCardTimePeriodFragment
    }
    dairySnacksWastage {
      ...ScoreCardTimePeriodFragment
    }
    tobaccoWastage {
      ...ScoreCardTimePeriodFragment
    }
    frozenProductsWastage {
      ...ScoreCardTimePeriodFragment
    }
  }
  ${timePeriodFragment}
`

export const fetchStationScoreCardStats = gql`
  query FetchStationScoreCardStats($stationId: ID!) {
    scoreCardStats: newScoreCardStationStats(stationId: $stationId) {
      ...ScoreCardFragment
    }
  }
  ${scoreCardFragment}
`

export const fetchChainScoreCardStats = gql`
  query FetchChainScoreCardStats {
    scoreCardStats: scoreCardChainStats {
      ...ScoreCardFragment
    }
  }
  ${scoreCardFragment}
`
